import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function ThankYou() {
  const location = useLocation();
  const name = (location.state as {
    name?: string;
  } | null)?.name?.split(' ')[0];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-129" data-mp="2to2ymrrqoz8o">
      <Header minimal data-id="element-130" data-mp="2xpy2o4121qq5" />

      <main className="flex flex-1 items-center justify-center px-5 py-20 lg:py-28" data-id="element-131" data-mp="2xp4qgnjbu90m">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="w-full max-w-2xl rounded-md bg-white p-8 text-center shadow-xl ring-1 ring-sand sm:p-12" data-id="element-132" data-mp="32izgs9tftm8o">
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-forest" data-id="element-133" data-mp="287h28cknj41k">
            <CheckCircleIcon className="h-11 w-11 text-gold-light" data-id="element-134" data-mp="235hz93stq955" />
          </span>

          <h1 className="mt-7 font-display text-4xl leading-tight text-forest sm:text-5xl" data-id="element-135" data-mp="1y8htyv3staf3">
            Thank You{name ? `, ${name}` : ''}
          </h1>
          <div className="mx-auto mt-4 h-0.5 w-16 bg-gold" data-id="element-136" data-mp="2qw48gyekdzgq" />

          <p className="mx-auto mt-6 max-w-lg font-serif text-lg leading-relaxed text-neutral-700" data-id="element-137" data-mp="2qvm1b6qd60u1">
            Your request has been received. A Brightwood senior living
            specialist will reach out shortly to help schedule your private tour
            of our 50-acre community.
          </p>
        </motion.div>
      </main>

      <Footer data-id="element-138" data-mp="39mn09urhhwdl" />
    </div>;
}